module.exports = __webpack_public_path__ + "img/360-lager-2.5a208e86.jpg";